import PopupAlert from '.';

export default {
    Component: PopupAlert,
    id: 'global-popup-alert-container',
};
